<template>
  <div class="group">
    <el-col :span="Number($attrs.config.grid)">
      <el-form-item :label="jyyj.label" :prop="jyyj.post" :rules="jyyj.rules">
        <el-select
          v-model="$attrs.model[jyyj.post]"
          :placeholder="jyyj.options.placeholder"
          @change="changeHandle"
          :style="{ width: jyyj.options.width }"
          :clearable="jyyj.options.clearable"
          :disabled="jyyj.options.disabled"
        >
          <el-option v-for="op in jyyj.options.valueData" :key="op.label" :label="op.label" :value="String(op.value)"> </el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="Number($attrs.config.grid)">
      <el-form-item :label="jyff.label" :prop="jyff.post" :rules="jyff.rules" v-if="$attrs.model[jyyj.post] == 2">
        <el-select
          v-model="$attrs.model[jyff.post]"
          :placeholder="jyff.options.placeholder"
          multiple
          filterable
          remote
          :remote-method="remoteMethod"
          :style="{ width: jyff.options.width }"
          :clearable="jyff.options.clearable"
          :disabled="jyff.options.disabled"
        >
          <el-option v-for="op in stdOptions" :key="op.prn" :label="op.nameCn" :value="String(op.nameCn)"> </el-option>
        </el-select>
      </el-form-item>
    </el-col>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      isShow: false,
      stdOptions: [],
    };
  },
  computed: {
    jyyj() {
      return this.item["list"][0];
    },
    jyff() {
      return this.item["list"][1];
    },
  },
  methods: {
    remoteMethod(val) {
      this.$http.get(this.$api.limsApi.stdList, { params: { name: val } }).then(({ data }) => {
        console.log(data);
        this.stdOptions = data.data;
      });
    },
    changeHandle(val) {
      if (val == 2) {
        this.isShow = true;
      } else {
        this.$attrs.model[this.jyff.post] = "";
        this.isShow = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
